/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GovernanceConfigurationBaseForVulnerabilities extends models.GovernanceConfigurationBaseForSecurity {
    getFixupPrototypeFunction() { return GovernanceConfigurationBaseForVulnerabilities.fixupPrototype; }

    static newInstance(model: Partial<GovernanceConfigurationBaseForVulnerabilities>): GovernanceConfigurationBaseForVulnerabilities {
        let obj = Object.assign(new GovernanceConfigurationBaseForVulnerabilities(), model);
        GovernanceConfigurationBaseForVulnerabilities.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GovernanceConfigurationBaseForVulnerabilities>): GovernanceConfigurationBaseForVulnerabilities {
        if (!model) return null;
        return GovernanceConfigurationBaseForVulnerabilities.newInstance(<GovernanceConfigurationBaseForVulnerabilities> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GovernanceConfigurationBaseForVulnerabilities) {
        if (!obj) return;

        models.GovernanceConfigurationBaseForVulnerabilities.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GovernanceConfigurationBaseForVulnerabilities): boolean {
        if (models.GovernanceConfigurationBaseForSecurity.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, GovernanceConfigurationBaseForVulnerabilities.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
